import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What is stump grinding and how does it work?',
      answer: 'Stump grinding is a professional tree service that uses specialized machinery to mechanically grind tree stumps below ground level. Our tracked stump grinder features a rotating cutting wheel with carbide teeth that chips away at the wood, reducing the stump to small wood chips and sawdust. The process typically grinds 6-12 inches below the soil surface, effectively removing the visible stump and preventing regrowth. The remaining wood chips can be used as mulch or removed from your property.'
    },
    {
      question: 'Will stump grinding damage my lawn or landscaping?',
      answer: 'Professional stump grinding causes minimal damage to surrounding areas. Our compact tracked equipment is designed to navigate residential properties with care, fitting through gates as narrow as 36 inches. While there will be some disturbance immediately around the stump, we take precautions to protect your lawn, flower beds, and existing landscaping. After grinding, we can fill the hole with the wood chip mulch or topsoil, and grass typically regrows within a few weeks.'
    },
    {
      question: 'What happens to the roots after stump grinding?',
      answer: 'Stump grinding removes the main stump and major surface roots, typically grinding 6-12 inches below ground level. The remaining roots left in the soil will naturally decompose over time, usually within 5-10 years depending on the tree species. These decaying roots actually add nutrients back to your soil. If you need deeper root removal for construction or planting purposes, we offer root pruning services that can address roots extending beyond the grinding area.'
    },
    {
      question: 'Can you grind stumps in hard-to-reach areas or backyards?',
      answer: 'Yes! Our tracked stump grinding equipment is specifically designed for residential properties with limited access. The machine fits through standard 36-inch gates and can navigate around obstacles, fences, and landscaping features. We regularly service stumps in backyards, side yards, and areas that larger equipment cannot reach. During your free estimate, we assess access points and plan the most efficient route to minimize any impact on your property.'
    },
    {
      question: 'Is stump grinding better than stump removal?',
      answer: 'For most residential and commercial applications, stump grinding is the preferred method. It is faster, more affordable, and causes less disruption to your landscape than complete stump removal (which requires excavating the entire root ball). Stump grinding is ideal when you plan to plant grass, install landscaping, or simply want the stump gone. Complete removal is only necessary for construction projects requiring deep excavation or when the entire root system must be eliminated.'
    },
    {
      question: 'What areas do you service in Metro Atlanta?',
      answer: 'Atlanta Stump Grinding Pros proudly serves Northwest Metro Atlanta, including Marietta, Smyrna, Vinings, and Buckhead. We also service surrounding communities in Cobb County and North Fulton County. Our service area covers residential neighborhoods, commercial properties, and HOA communities throughout the region. Contact us to confirm service availability in your specific location and schedule your free estimate.'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-emerald-100 text-emerald-700 text-xs font-semibold rounded-full mb-4">
            FREQUENTLY ASKED QUESTIONS
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Stump Grinding FAQs
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Get answers to common questions about professional stump grinding services in Atlanta, Georgia
          </p>
        </div>

        <div className="space-y-4" itemScope itemType="https://schema.org/FAQPage">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              itemScope 
              itemProp="mainEntity" 
              itemType="https://schema.org/Question"
              className="bg-white rounded-xl border border-gray-200 overflow-hidden transition-all duration-300 hover:border-emerald-200"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer"
              >
                <h3 itemProp="name" className="text-base font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${openIndex === index ? 'bg-emerald-600 rotate-180' : 'bg-gray-100'}`}>
                  <i className={`ri-arrow-down-s-line text-lg ${openIndex === index ? 'text-white' : 'text-gray-600'}`}></i>
                </div>
              </button>
              
              <div 
                itemScope 
                itemProp="acceptedAnswer" 
                itemType="https://schema.org/Answer"
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
              >
                <div itemProp="text" className="px-6 pb-5 text-sm text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
